// Link in all MAIN addon reducers here

import { pnMediaCatalog } from './PNMediaCatalog/reducers';
import { pnCollectionPage } from './PNCollectionPage/reducers';
import { pnGenericGridView } from './PNGenericGridView/reducers';
import { pnOrganizationSelector } from './PNOrganizationSelector/reducers';
import { pnLoggedOnInfoLabel } from './PNLoggedOnInfoLabel/reducers';
import { pnGenericForm } from './PNGenericForm/reducers';
import { pnGenericDataView } from './PNGenericDataView/reducers';
import { pnGtmEnhancedEcom } from './PNGtmEnhancedEcom/reducers';
import { pnOrganizationsMapPage } from './PNOrganizationsMapPage/reducers';
import { pnNewsletterSignup } from './PNNewsletterSignup/reducers';
import { pnProductConfigurator } from './PNProductConfigurator/reducers';

export const addonReducers = {
  ...pnMediaCatalog,
  ...pnCollectionPage,
  ...pnGenericGridView,
  ...pnOrganizationSelector,
  ...pnLoggedOnInfoLabel,
  ...pnGenericForm,
  ...pnGtmEnhancedEcom,
  ...pnGenericDataView,
  ...pnOrganizationsMapPage,
  ...pnNewsletterSignup,
  ...pnProductConfigurator,
};
